module.exports = __webpack_public_path__ + "static/hamburger-c2d14d7fc11e2f435135e9ff12c3207b.svg";